export default __webpack_public_path__ + "a7e06560e456e6b1d13f3a7139b2e179.woff2";